import { Reducer } from 'redux';
import { IAction } from '../types';
import LocalStore from '@/utils/store';

export interface IframeDanmuInfoState {
  infoType: string;
  info: any;
}

const localGameInfo = LocalStore.getValue<IframeDanmuInfoState>('IFRAME_DANMU_LIVE') || {};

export const iframeDanmuInfo: IframeDanmuInfoState = {
  infoType: '',
  info: {},
  ...localGameInfo
};

export const setIframeDanmuInfo: (payload: IframeDanmuInfoState) => IAction<IframeDanmuInfoState> = (
  payload: IframeDanmuInfoState
) => ({
  type: 'setIframeDanmuInfo',
  payload
});

const iframeDanmuInfoReducer: Reducer<IframeDanmuInfoState, IAction<any>> = (
  state = iframeDanmuInfo,
  action: IAction<any>
) => {
  const { type, payload } = action;
  switch (type) {
    case 'setIframeDanmuInfo':
      LocalStore.setValue('IFRAME_DANMU_LIVE', payload);
      return {
        ...payload
      };
    default:
      return state;
  }
};

export default iframeDanmuInfoReducer;
